import { TFunction } from "i18next";
import { useNavigate } from "react-router-dom";

import { Button, Text } from "@pentabd/ui";

import { ContactColumn, ProfileInfoCard } from "@components";

import { EmployeeCommonInfoType } from "@type/HRM/employee-common-info";

export const EmployeeListTableColumn = (
  t: TFunction<"translation", undefined>,
) => {
  const navigate = useNavigate();

  return [
    {
      id: 1,
      key: "nameBn",
      name: t("INVENTORY_EMPLOYEE.EMPLOYEE.EMPLOYEE_TABLE.COLUMN.NAME"),
      render: (_: string, row: EmployeeCommonInfoType) => (
        <ProfileInfoCard employee={row.employee} viewProfile />
      ),
    },
    {
      id: 2,
      key: "employeeCode",
      name: t("INVENTORY_EMPLOYEE.EMPLOYEE.EMPLOYEE_TABLE.COLUMN.EMPLOYEE_ID"),
      render: (_: string, row: EmployeeCommonInfoType) => (
        <Text color="subtitle2">{row.employee.employeeCode}</Text>
      ),
    },
    // {
    //   id: 3,
    //   key: "employeeCode",
    //   name: t("INVENTORY_EMPLOYEE.EMPLOYEE.EMPLOYEE_TABLE.COLUMN.OFFICE"),
    //   render: (_: string, row: EmployeeCommonInfoType) => (
    //     <Text color="subtitle1">{row.employee.officeName}</Text>
    //   ),
    // },
    {
      id: 4,
      key: "email",
      name: t("INVENTORY_EMPLOYEE.EMPLOYEE.EMPLOYEE_TABLE.COLUMN.CONTACTS"),
      render: (_: string, row: EmployeeCommonInfoType) => (
        <ContactColumn employee={row} />
      ),
    },
    {
      id: 5,
      key: "asstNo",
      name: t("INVENTORY_EMPLOYEE.EMPLOYEE.EMPLOYEE_TABLE.COLUMN.ASSET_NO"),
      render: (asstNo: number) => (
        <Text color="subtitle1">{asstNo || "..."}</Text>
      ),
    },
    {
      id: 6,
      key: "itemNo",
      name: t("INVENTORY_EMPLOYEE.EMPLOYEE.EMPLOYEE_TABLE.COLUMN.ITEM_NO"),
      render: (itemNo: number) => (
        <Text color="subtitle1">{itemNo || "..."}</Text>
      ),
    },
    {
      id: 7,
      key: "view",
      name: "",
      render: (_: string, row: EmployeeCommonInfoType) => {
        return (
          <Button
            fill="outline"
            type="light"
            size="xs"
            htmlType="button"
            onClick={() => navigate(`${row.employee.id}`)}
          >
            {t("INVENTORY_BUDGET_LIST.TABLE.DETAILS_BUTTON")}
          </Button>
        );
      },
    },
  ];
};
